import { TFunction } from 'i18next';
import { SubLimit } from './types';
import { UpsertSubLimitPayloadDto } from 'libs/pinnacle-sdk';
import { ValidationError } from 'components/ui/excel-table/types';

export const validateSubLimit = (
  row: SubLimit,
  rowIndex: number,
  subLimits: SubLimit[],
  t: TFunction
): ValidationError<SubLimit>[] => {
  const errors: ValidationError<SubLimit>[] = [];
  // Check for duplicate peril + country combination
  const currentCombo = `${row.peril}-${row.country}`;
  const isDuplicate = subLimits.some((otherRow, otherIndex) => {
    if (otherIndex === rowIndex) return false;
    return `${otherRow.peril}-${otherRow.country}` === currentCombo;
  });

  if (isDuplicate) {
    errors.push({
      field: 'peril',
      rowIndex,
      message: t('subLimits.validation.duplicatePerilCountry'),
    });
    errors.push({
      field: 'country',
      rowIndex,
      message: t('subLimits.validation.duplicatePerilCountry'),
    });
  }

  // Layer Number validation
  if (!row.layerNumber || row.layerNumber <= 0) {
    errors.push({
      field: 'layerNumber',
      rowIndex,
      message: t('subLimits.validation.layerNumberRequired'),
    });
  }

  // Currency validation
  if (!row.currency) {
    errors.push({
      field: 'currency',
      rowIndex,
      message: t('subLimits.validation.currencyRequired'),
    });
  }

  // Country validation
  if (!row.country) {
    errors.push({
      field: 'country',
      rowIndex,
      message: t('subLimits.validation.countryRequired'),
    });
  }

  // Peril validation
  if (!row.peril) {
    errors.push({
      field: 'peril',
      rowIndex,
      message: t('subLimits.validation.perilRequired'),
    });
  }

  // Sub-limit amount validation
  if (!row.subLimitAmount || row.subLimitAmount <= 0) {
    errors.push({
      field: 'subLimitAmount',
      rowIndex,
      message: t('subLimits.validation.subLimitAmountRequired'),
    });
  }

  return errors;
};

export const convertSubLimitsToPayload = (
  rows: SubLimit[]
): Array<UpsertSubLimitPayloadDto> => {
  return rows.map((row) => ({
    subLimitId: row.subLimitId,
    currency: row.currency,
    country: row.country,
    peril: row.peril,
    amount: String(row.subLimitAmount),
  }));
};
